export default {"src":"/_next/static/media/RUB.1306d7ec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};